module.exports = __webpack_public_path__ + "assets/img/6_535_big.3d812ce7.jpg";